import { Button } from '@mui/material';
import React from 'react';
import { LANG_DICTIONARY } from 'src/common/lang-constants';

export const useLanguageTabs = () => {
  const [lang, setLang] = React.useState<string>(Object.keys(LANG_DICTIONARY)[0]);
  const renderTabsButtons = () => {
    return Object.keys(LANG_DICTIONARY).map((code) =>
      React.createElement(
        Button,
        {
          size: 'small',
          variant: lang === code ? 'contained' : 'text',
          onClick: () => setLang(code),
          key: code,
        },
        LANG_DICTIONARY[code].label
      )
    );
  };
  return {
    tabLang: lang,
    renderTabsButtons,
  };
};
